export default __webpack_public_path__ + "static/banner-crm-7266194ee72b7c10abc67d83fb745127.jpg";